import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Group = styled(ToggleButtonGroup)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? theme.palette.grey[900]
      : theme.palette.grey[100],
  borderRadius: 999,
  padding: 2,
  gap: 2,
  height: 36,
  flexShrink: 0,

  "& .MuiToggleButtonGroup-grouped": {
    border: 0,
    borderRadius: "999px !important",
    margin: 0,
  },

  "&.MuiToggleButtonGroup-fullWidth .MuiToggleButtonGroup-grouped": {
    flex: "1 1 0",
    minWidth: 0,
  },
}));

export const Tab = styled(ToggleButton)(({ theme }) => ({
  height: 32,
  padding: theme.spacing(0, 1.75),
  textTransform: "none",
  whiteSpace: "nowrap",
  color: theme.palette.text.secondary,

  "&&.Mui-disabled": {
    opacity: 1,
    border: 0,
    boxShadow: "none",
    color: theme.palette.text.secondary,
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.grey[800]
        : theme.palette.grey[200],
  },

  "&&.Mui-selected": {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    boxShadow:
      "0px 1px 3px rgba(16, 24, 40, 0.12), 0px 1px 2px rgba(16, 24, 40, 0.08) !important",

    "&:hover": {
      backgroundColor: theme.palette.background.paper,
    },
  },
}));

export const TabContainer = styled("span", {
  shouldForwardProp: (prop) => prop !== "$fullWidth",
})<{ $fullWidth: boolean }>(({ $fullWidth }) => ({
  display: "flex",
  flex: $fullWidth ? "1 1 0" : "0 0 auto",
  minWidth: 0,

  "& > button": {
    width: $fullWidth ? "100%" : "auto",
  },
}));
